import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import {setStockoutproducttoproductorderSorting} from 'store/slice/ManufSlice';

export default function StockoutproducttoproductorderListTableHeader(){
  const dispatch = useDispatch();
  const {sorting} = useSelector((state) => state.manufslice.stockoutproducttoproductorderDashboard);
  
  const handleColumnClick = (column) => {
  const currentSorting = sorting.column === column ? !sorting.asc : true;
    dispatch(setStockoutproducttoproductorderSorting({ column, asc: currentSorting }));     
  }
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>

            {/* <HEADER - CELLS/> */}
        
                        <Grid item lg={2} xs={1} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('title')}> Title </Typography></Grid>
                        <Grid item lg={1} xs={1} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('stockoutproductid')}> stockoutproductid </Typography></Grid>
                        <Grid item lg={1} xs={1} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('productorderid')}> productorderid </Typography></Grid>
                        <Grid item lg={1} xs={1} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('orderid')}> Order Id </Typography></Grid>

      </Grid>
      
    )
}